import { useState } from 'react';
import IndexPage from './containers/IndexPage';
import { Route, Switch } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
import './App.css';
import SinglePointDisplay from './components/SinglePointDisplay';
import MultiPointDisplay from './components/MultiPointDisplay';
import Header from './containers/Header';
import Footer from './containers/Footer';
import { AppContextProvider, initialAppState } from './context/AppContext';
import HelmTabs from './components/converters/helm/HelmTabs';
import GeoLestTabs from './components/converters/geolest/GeoLestTabs';
import GeoidTabs from './components/converters/geoid/GeoidTabs';
import GaussGlobalTabs from './components/converters/gauss/GaussGlobalTabs';
import YmudelTabs from './components/converters/ymudel/YmudelTabs';
import CrdMudelTabs from './components/converters/crdmudel/CrdMudelTabs';
import ValgaCrdMudelTabs from './components/converters/crdmudel/ValgaCrdMudelTabs';
import HMudelTabs from './components/converters/hmudel/HMudelTabs';

function App() {

  const setNumberOfResults = (numberOfResults: string | null): void => {
    setAppState({...appState, numberOfResults});
}

const [appState, setAppState] = useState({...initialAppState, setNumberOfResults });

  return (
    <>
      <I18nextProvider i18n={i18n}>
        <AppContextProvider value={appState} >
          <Header />
          <div className="container">
            <main role="main" className="pb-3">
              <Switch>
                <Route path="/geolocation/:refNrId" component={SinglePointDisplay} />
                <Route path="/multiplelocations/:searchType" component={MultiPointDisplay} />
                <Route path="/geolest/:activeTab" component={GeoLestTabs} />
                <Route path="/geolest" component={GeoLestTabs} />
                <Route path="/gauss/:activeTab" component={GaussGlobalTabs} />
                <Route path="/gauss" component={GaussGlobalTabs} />
                <Route path="/helm/:activeTab" component={HelmTabs} />
                <Route path="/helm" component={HelmTabs} />
                <Route path="/ymudel/:activeTab" component={YmudelTabs} />
                <Route path="/ymudel" component={YmudelTabs} />
                <Route path="/geoid2017/:activeTab" component={GeoidTabs} />
                <Route path="/geoid2017" component={GeoidTabs} />
                <Route path="/crdmudel/:activeTab" component={CrdMudelTabs} />
                <Route path="/crdmudel" component={CrdMudelTabs} />
                <Route path="/valgacrdmudel/:activeTab" component={ValgaCrdMudelTabs} />
                <Route path="/valgacrdmudel" component={ValgaCrdMudelTabs} />
                <Route path="/hmudel/:activeTab" component={HMudelTabs} />
                <Route path="/hmudel" component={HMudelTabs} />
                <Route exact path="/" component={IndexPage} />
              </Switch>
            </main>
          </div>
          <Footer />
        </AppContextProvider>
      </I18nextProvider>
    </>
  );
}

export default App;
